export const sectionsForFilterType = {
    nyhed: {
        click: ['Content', 'Demographics', 'System', 'Device'],
        pageview: ['Content'],
    },
    jobopslag: {
        click: ['Demographics', 'System', 'Device'],
        pageview: ['Content'],
    },
    maskine: {
        click: ['Content', 'Demographics', 'System', 'Device'],
        pageview: ['Content'],
    },
    profil: {
        click: ['Demographics', 'System', 'Device'],
        pageview: ['Content'],
    },
    kurser: {
        click: ['Content', 'Demographics', 'System', 'Device'],
        pageview: ['Content'],
    },
    produkter: {
        click: ['Content', 'Demographics', 'System', 'Device'],
        pageview: ['Content'],
    },
};

export const sectionsInfo = {
    Content: {
        i18nId: "analyticsTabContent",
        items: ['documentPath', 'documentTitle', 'tags'],
    },
    Demographics: {
        i18nId: "analyticsTabDemographics",
        items: ['language'],
    },
    System: {
        i18nId: "analyticsTabSystem",
        items: ['browser', 'os', 'encoding'],
    },
    Device: {
        i18nId: "analyticsTabDevice",
        items: ['device', 'screenResolution'],
    },
};


// WEBPACK FOOTER //
// ./web/src/components/analytics/metrics/sectionsConfig.jsx